import { apiService } from './apiService';
import { SideBarMenu } from '../interfaces/system/SidebarNavConfig';

type GetGoHighLevelAuthorizationLinkResponse = {
  redirectUrl: string;
};

export const systemService = {
  async getGoHighLevelAuthorizationLink() {
    const resp = await apiService.get<GetGoHighLevelAuthorizationLinkResponse>(
      'api/oauth/marketplace/authorization-link',
    );

    return resp.data;
  },

  async getSidebarMenuConfig() {
    const resp = await apiService.get<SideBarMenu>('api/navigation/sidebar');

    return resp.data;
  },
};
